import React, { useState } from "react";
import {
  View,
  FlatList,
  StyleSheet,
  Text,
  ScrollView,
  Dimensions,
  ImageBackground,
  Image,
  TouchableOpacity,
  TouchableHighlight,
} from "react-native";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import { Triptone, Triptwo } from "../../Constants/Data";

const { height, width } = Dimensions.get("screen");

const TripManagement = ({ navigation }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedIndexone, setSelectedIndexOne] = useState(null);

  const handleItemSelection = (index) => {
    setSelectedIndex(index);
    setSelectedIndexOne(null); // clear the selection in the other FlatList
  };

  const handleItemSelectionone = (index) => {
    setSelectedIndexOne(index);
    setSelectedIndex(null); // clear the selection in the other FlatList
  };
  return (
    <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
      <View style={Appstyles.headerview}></View>

      <ScrollView
        style={styles.scrollView}
        showsVerticalScrollIndicator={false}
      >
        <View
          style={{
            backgroundColor: "white",
            marginTop: 120,
            borderRadius: 12,
            flexDirection: "row",
            flex: 1,
            paddingHorizontal: 20,
            justifyContent: "space-between",
          }}
        >
          <View
            style={{
              width: "50%",
              alignItems: "flex-start",
              marginTop: -height * 0.05,
              borderRadius: 10,
            }}
          >
            {Triptwo.map((item, index) => (
              <TouchableOpacity
                onPress={() => [
                  handleItemSelection(index),
                  navigation.navigate(item.nav),
                ]}
                //key={item.id}
                style={{
                  alignItems: "center",
                  marginBottom: 20,
                  height: height * 0.2,
                  borderRadius: 10,
                }}
                underlayColor="transparent"
              >
                <View style={{ backgroundColor: "white", borderRadius: 10 }}>
                  {index === selectedIndex ? (
                    <View style={Appstyles.seleCard}>
                      <View style={{ alignItems: "center", width: "85%" }}>
                        <Image
                          source={item.img}
                          style={Appstyles.cardImg}
                          resizeMode="contain"
                        />
                        <Text style={[Appstyles.seleText]}>{item.title}</Text>
                      </View>
                    </View>
                  ) : (
                    <View style={Appstyles.notselView}>
                      <View
                        style={{
                          alignItems: "center",
                          width: "85%"
                        }}
                      >
                        <Image
                          source={item.img}
                          style={Appstyles.cardImg}
                          resizeMode="contain"
                        />
                        <Text style={[Appstyles.NoseleText]}>{item.title}</Text>
                      </View>
                    </View>
                  )}
                </View>
              </TouchableOpacity>
            ))}
          </View>

          {/* ... */}
          <View style={{ width: "50%", alignItems: "flex-end", marginTop: 20 }}>
            {Triptone.map((item, index) => (
              <TouchableOpacity
                onPress={() => [
                  handleItemSelectionone(index),
                  navigation.navigate(item.nav),
                ]}
                //key={item.id}
                style={{
                  alignItems: "flex-end",
                  justifyContent: "flex-end",

                  borderRadius: 10,
                  marginTop: 20,
                  height: height * 0.2,
                }}
                underlayColor="transparent"
              >
                <View style={{ backgroundColor: "white", borderRadius: 10 }}>
                  {index === selectedIndexone ? (
                    <View style={Appstyles.seleCard}>
                      <View style={{ alignItems: "center", width: "85%" }}>
                        <Image
                          source={item.img}
                          style={Appstyles.cardImg}
                          resizeMode="contain"
                        />
                        <Text style={[Appstyles.seleText]}>{item.title}</Text>
                      </View>
                    </View>
                  ) : (
                    <View style={Appstyles.notselView}>
                      <View
                        style={{
                          alignItems: "center",
                          width: "85%",
                        }}
                      >
                        <Image
                          source={item.img}
                          style={Appstyles.cardImg}
                          resizeMode="contain"
                        />
                        <Text style={[Appstyles.NoseleText]}>{item.title}</Text>
                      </View>
                    </View>
                  )}
                </View>
              </TouchableOpacity>
            ))}
            {/* Add other views here using the same map approach if needed */}
          </View>
        </View>
      </ScrollView>
      <ImageBackground
        source={AppImages.blurMap}
        style={{ height: height * 0.4, width: "100%", position: "absolute" }}
        imageStyle={{
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
        }}
      >
        <View style={Appstyles.headerview}>
          <View style={Appstyles.fullAlignment}>
            {/* <TouchableOpacity
          style={Appstyles.goback}
          onPress={() => navigation.navigate("DrawerScreen")}
        >
          <Image
            source={AppImages.Backbtn}
            style={{ width: 8, height: 15 }}
          />
        </TouchableOpacity> */}
            <TouchableOpacity onPress={() => navigation.toggleDrawer()}>
              <Image
                source={AppImages.Drawer}
                style={{ width: 21, height: 22, resizeMode: "contain" }}
              />
            </TouchableOpacity>
          </View>
          <Text
            style={{
              color: AppColors.brown,
              fontFamily: AppFonts.OverpassMedium,
              fontSize: 16,
              // textAlign:"center"
            }}
          >
            Trip Management{" "}
          </Text>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
              <Image
                source={AppImages.Bellnoti}
                style={{ width: 16, height: 20 }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      </ImageBackground>
    </View>
  );
};
export default TripManagement;

const styles = StyleSheet.create({
  scrollView: {
    height: height * 0.2, // Adjust the height as desired
    zIndex: 1,
    marginTop: 0,
    backgroundColor: "transparent",
    marginHorizontal: 20,
    marginBottom: 20,
  },
});
